import React from "react";

import Button from "@cayuse/shared-react.components.button";
import IconButton from "@cayuse/shared-react.components.icon-button";
import { useDictionary } from "hooks/useDictionary";
import { useSelector } from "react-redux";
import { budgetBuilderSelectors } from "store/selectors";

const ResearchButtons = (
	{
		isEditing,
		isModified,
		isValid,
		handleReset,
		setIsEditing,
		handleSave,
		setAddSponsorCostsModalOpen,
	}
) => {
	const dictionary = useDictionary("budgetBuilder.buttonLabels");
	const isLoading = useSelector(budgetBuilderSelectors.isFetching);
	const cancelButton = (
		<Button disabled={!isEditing} onClick={() => handleReset()} secondary>
			{dictionary.cancel || "Cancel"}
		</Button>
	);

	const editButton = isEditing
		? (
			<IconButton
				key="save"
				icon="save"
				labelPosition="left"
				disabled={!isModified || !isValid}
				busy={isLoading}
				onClick={handleSave}
			>
				{dictionary.save || "Save"}
			</IconButton>
		)
		: (
			<IconButton key="edit" labelPosition="left" onClick={() => setIsEditing(true)}>
				{dictionary.edit || "Edit"}
			</IconButton>
		);

	const addPersonButton = (
		<IconButton
			key="add"
			icon="plus"
			labelPosition="left"
			onClick={() => setAddSponsorCostsModalOpen(true)}
		>
			{dictionary.addPerson || "Add Person"}
		</IconButton>
	);

	return ([ cancelButton, editButton, addPersonButton ]);
};

export default ResearchButtons;
